import { render, staticRenderFns } from "./vat.vue?vue&type=template&id=6de14a25&scoped=true"
import script from "./vat.vue?vue&type=script&lang=js"
export * from "./vat.vue?vue&type=script&lang=js"
import style0 from "./TreatmentStepTwoForms.styles.scss?vue&type=style&index=0&id=6de14a25&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de14a25",
  null
  
)

export default component.exports